import { IconButton, Modal, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';

import { Keyboard, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

SwiperCore.use([Navigation, Pagination, Keyboard]);

export const ImageModal = ({ openModal, onCloseModal, imgIndex, setImgIndex, modalImages, editedIds }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Modal open={openModal} onClose={onCloseModal}>
      <Box
        sx={{
          width: isMobile ? '90%' : 500,
          margin: 'auto',
          mt: isMobile ? 7 : 16,
          outline: 'none',
        }}
      >
        {isMobile && (
          <IconButton
            onClick={onCloseModal}
            sx={{
              position: 'absolute',
              top: 5,
              right: 8,
              zIndex: 10,
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              '&:hover': { backgroundColor: 'rgba(20, 0, 0, 0.6)' },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <Swiper
          initialSlide={imgIndex}
          navigation
          pagination={{ clickable: true }}
          keyboard={{ enabled: true }}
          onSlideChange={(swiper) => setImgIndex(swiper.activeIndex)}
        >
          {modalImages.map((image, index) => (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  width: '100%',
                  height: isMobile ? 560 : 500, // Fixed height for consistency
                  backgroundColor: '#f5f5f5',
                  overflow: 'hidden', // Ensures no content spills out
                }}
              >
                {/* The image */}
                <img
                  // src={BASE_URL + image.url}
                  src={image}
                  alt={`Ticket ${index + 1}`}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain', // Scales the image while maintaining aspect ratio
                  }}
                />

                <IconButton
                  onClick={onCloseModal}
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 30,
                    color: 'rgba(0, 0, 0, 0.6)',
                  }}
                >
                  <ClearOutlinedIcon />
                </IconButton>

                {/* Delete icon positioned relative to the image */}
                {Object.keys(editedIds).length > 0 && (
                  <IconButton
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      zIndex: 20,
                      color: 'red',
                      backgroundColor: 'rgba(255, 0, 0, 0.6)',
                      '&.MuiIconButton-root:hover': {
                        backgroundColor: 'rgba(255, 0, 0, 0.9)',
                      },
                    }}
                  >
                    <DeleteIcon style={{ color: 'white' }} />
                  </IconButton>
                )}
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Modal>
  );
};
